import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject, Subscription, TimeoutError, filter, forkJoin, takeUntil } from 'rxjs';
import { StorageHelper } from 'src/app/_utilities/storage-helper';
import { CommonService } from '../../services/common/common.service';
import { SlugifyPipe } from '../../_shared/pipes/slugify.pipe';
import { ArticleService } from 'src/app/services/article/article.service';
import { CreateCustomerPortalRequest, CreateCustomerPortalResponse, GetProfileListResponse, profileDetail } from 'src/app/_shared/models/article';
import { TemplateHelperService } from 'src/app/_shared/services/helper/template-selector/template-helper.service';
import { TokenService } from '../../services/token/token.service';
import { UserInfo } from '../../_shared/models/common';
import { FEATURES, STRIPEACTIONS } from '../../_shared/consts/app-constants';
import { ContentStudioTrackingService } from 'src/app/_shared/services/tracking/contentstudio-tracking.service';
import { NewTemplateHelperService } from 'src/app/_shared/services/helper/new-template-selector/new-template-helper.service';
import { CampaignService } from 'src/app/services/campaign/campaign.service';
import { GetSettingsFileRequest } from '../../_shared/models/getsettingsfilerequest';
import { SettingsService } from '../../services/settings/settings.service';
@Component({
  selector: 'ms-dpr-basic-layout',
  templateUrl: './basic-layout.component.html',
  styleUrls: ['./basic-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class BasicLayoutComponent implements OnInit, OnDestroy {
  isCollapsed = false;
  isContentIntelEnable: boolean = false;
  isContentGenEnabled: boolean = false;
  isCampaignEnabled: boolean = false;

  getLeftMenuSubscription: Subscription;
  _storageHelper: StorageHelper;
  currentUrl: string = location.href;
  selectedProfileName: string = "";
  returnUrlToMPC: string = "";
  selectedLanguage: string = "en";
  openMap: { [name: string]: boolean } = {
    sub1: false,
    sub2: true,
    sub3: false
  };
  iconsList = [
    { oldName: 'Dashboard', newName: 'home-line' },
    { oldName: 'Marketing Tools', newName: 'line-chart-up-01' },
    { oldName: 'Manage Content', newName: 'layers-three-01' },
    { oldName: 'Manage Layout', newName: 'layers-three-01' },
    { oldName: 'Settings', newName: 'settings-01' },
    { oldName: 'SEO', newName: 'file-search-02' },
    { oldName: 'Bulk Operations', newName: 'copy-06' },
    { oldName: 'Manage Users', newName: 'users-01' },
    { oldName: 'Guest Portal', newName: 'globe-02' },
    { oldName: 'MiBlock', newName: 'layers-two-01' },
    { oldName: 'Newsroom', newName: 'announcement-02' },
    { oldName: 'Milestone Assets', newName: 'folder' },
  ];
  visible = false;
  selectedProfileId: any = '';
  profiles: profileDetail[] = [];
  filteredProfiles: profileDetail[] = [];
  isDamEnabled = false;
  dprBaseUrl = "";
  IsSaaSUser: boolean = true;
  IsTrialPeriod: boolean = true;
  userEmail: string = "";
  userName: string = "";
  businessInformationUrl: string;
  ManageSubscriptionSubMenuvisible: boolean = false;
  isCancelSubscription: boolean = false;
  showSupportPopup: boolean = false;
  trialEndDate: any;
  trialPeriodTooltip: string = "";
  pollingTimeout: any;
  //errorMessage = "Subscription is set to be canceled.";
  subscriptionCheckIntervalMinutes = 15;
  planType: string = "Enterprise";
  logoUrl: string = "";
  socialPostEnabled = false;
  socialPostAllowedBusinessIds = ['13119', '12229'];
  isCampaignInProgress: boolean = false;
  isCustomTemplatesEnabled: boolean;
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  isSettingsMenuOpen: boolean = false;
  // True when the article editor (create-detailed-post) is open. The editor is nested inside this
  // layout, so the "Create New Content" button is hidden there to avoid stray clicks opening the
  // template selector.
  isEditorRoute: boolean = false;
  isSettingsEnableKnowledgeVault: boolean = false;
  constructor(
    private cdRef: ChangeDetectorRef,
    private commonService: CommonService,
    private router: Router,
    private articleService: ArticleService,
    private templateHelperService: TemplateHelperService,
    private newTemplateHelperService: NewTemplateHelperService,
    private tokenService: TokenService,
    private tracking: ContentStudioTrackingService,
    private campaignService: CampaignService,
    private settingsService: SettingsService,
    private route: ActivatedRoute
  ) {
    this._storageHelper = new StorageHelper();
  }
  closeDropdown(value) {
    this.visible = value;
  }
  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
    if (this.pollingTimeout) {
      clearTimeout(this.pollingTimeout); // Clear timeout to avoid memory leaks
    }
  }
  ngOnInit(): void {
    this.businessInformationUrl = this._storageHelper.user.returnUrl + this._storageHelper.user.businessInformationUrl;
    this.userEmail = this._storageHelper.user.userName;
    this.planType = this._storageHelper.user.planId;
    this.commonService.getUserInfoValue().subscribe((res: UserInfo) => {
      if (res != null) {
        this.IsSaaSUser = res.isSaasUser;
        this.isSettingsEnableKnowledgeVault = res.enableKnowledgeVault;
        if (this.IsSaaSUser) {
          this.checkSubscriptionStatus(true);
          this.startCheckSubscriptionStatus();
        }
        this.IsTrialPeriod = res.isTrialPeriod;

        this.trialPeriodTooltip = 'Plan upgrade is not possible during trial period';
        if (res.trialEndDate != undefined && res.trialEndDate != null) {
          const date = new Date(res.trialEndDate);
          // Format the date as MM-DD-YYYY
          const formattedDate = `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}-${date.getFullYear()}`;
          this.trialPeriodTooltip += ' till ' + formattedDate;
        }
        this.userName = res.userFirstName + " " + res.userLastName;
        this.isContentIntelEnable = res.featureIds.includes(FEATURES.ContentIntelligenceFeatureName);
        this.isContentGenEnabled = res.featureIds.includes(FEATURES.ContentGenerationFeatureName);
        this.isCampaignEnabled = res.featureIds.includes(FEATURES.CampaignFeatureName);
        this.isCustomTemplatesEnabled = res.featureIds.includes(FEATURES.CustomTemplatesFeatureName);
      }
    });
    this.campaignService.isCampaignInProgress(this._storageHelper.user.pId).subscribe({
      next: (response) => {
        if (response && response.isInProgress !== undefined) {
          this.isCampaignInProgress = response.isInProgress;
        }
      },
      error: (err) => {
        console.error('Error checking campaign status', err);
      }
    });
    this.selectedProfileName = this._storageHelper.user.profileName;
    this.selectedLanguage = this._storageHelper.UserLanguage;
    this.returnUrlToMPC = this._storageHelper.user.returnUrl;
    this.isDamEnabled = this._storageHelper.user.isDamEnabled;
    this.dprBaseUrl = this._storageHelper.user.dprBaseUrl;
    //const filterPipe = new SlugifyPipe();
    //const fiteredArr = filterPipe.transform(this.blogCategory.slugUrl);
    //console.log(fiteredArr);
    this.returnUrlToMPC = this._storageHelper.user.returnUrl;
    this.logoUrl = (this._storageHelper.user.logoUrl !== null) ? this._storageHelper.user.logoUrl : "assets/images/logo-new.svg";
    this.getSettingsForm();
    
    // Check initial URL on component load
    this.isSettingsMenuOpen = this.router.url.includes('settings');
    this.isEditorRoute = this.router.url.includes('create-detailed-post');

    // Subscribe to future navigation events
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => {
        this.isSettingsMenuOpen = event.url.includes('settings');
        this.isEditorRoute = event.url.includes('create-detailed-post');
        this.cdRef.detectChanges();
      });

  }

  isCompetitorsSet: boolean = false;
  private destroy$: Subject<any> = new Subject();

  getSettingsForm() {
    let getSettingsFileRequest = new GetSettingsFileRequest();
    getSettingsFileRequest.ProfileId = this._storageHelper.user.pId;

    const getSettingsObservable = this.settingsService.getSettings<GetSettingsFileRequest>(getSettingsFileRequest);
    this.articleService.profileList = null;

    forkJoin({
      getSettingsResponse: getSettingsObservable,
      response: this.articleService.getProfileList()
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ response, getSettingsResponse }) => {
        if (getSettingsResponse !== null && getSettingsResponse !== undefined) {
     
            if (response.errorCode == 0) {

              if (response.profiles && response.profiles.length > 0) {
                if (response.profiles.filter(p => p.profileId === this._storageHelper.user.pId).length > 0) {
                  const selectedProfileId = response.profiles.filter(p => p.profileId === this._storageHelper.user.pId)[0];
                  console.log(!selectedProfileId.featureIds.includes("_con_content_intelligence"));
                  this.competitorsTabDisabled = !selectedProfileId.featureIds.includes("_con_content_intelligence");
                  // if (this.competitorsTabDisabled) {
                  //   this.selectedTab = 1;
                  // }
                }
                this.articleService.profileList = response.profiles;
                this.profiles = response.profiles;
                this.filteredProfiles = response.profiles;
                this.selectedProfileId = this._storageHelper.user.pId;
                if (response.profiles.filter(p => p.profileId === this._storageHelper.user.pId).length > 0) {
                  const selectedProfileId = response.profiles.filter(p => p.profileId === this._storageHelper.user.pId)[0];
                  this.articleService.IsContentIntelligenceEnabled = selectedProfileId.featureIds.includes("_con_content_intelligence");
                }
              }
            } else {
              //this.msg.error(response.message);
            }
       
        var competitorUrl1 = getSettingsResponse.competitorUrl1 ? getSettingsResponse.competitorUrl1.slice(8) : '';
        var competitorUrl2= getSettingsResponse.competitorUrl2 ? getSettingsResponse.competitorUrl2.slice(8) : '';
        var competitorUrl3= getSettingsResponse.competitorUrl3 ? getSettingsResponse.competitorUrl3.slice(8) : '';

          if (competitorUrl1 != ""
            || competitorUrl2 != ""
            || competitorUrl3 != "") {
            this.isCompetitorsSet = true;
            //setTimeout(() => {
            //  this.commonService.settingsActiveTab$.subscribe((tab: number) => {
            //    this.selectedTab = tab;
            //    this.cdr.detectChanges();
            //  });
            //},10);
            //this.isSettingsLoading = false;
          } else {
            //this.isSettingsLoading = false;
          }

          this.cdRef.detectChanges();
        }
      
      });
  }

  startCheckSubscriptionStatus() {
    this.pollingTimeout = setTimeout(() => {
      this.checkSubscriptionStatus();
    }, this.subscriptionCheckIntervalMinutes * 60 * 1000);
  }

  checkSubscriptionStatus(isFirstCall: boolean = false): void {
    this.commonService.isSubscriptionExpired(+this._storageHelper.user.bId)
      .subscribe({
        next: (response) => {
          if (response) {
            if (response.isSubscriptionCanceled) {
              window.location.href = this._storageHelper.user.returnUrl + "account/subscription-cancelled";
            }
          }
          if (!isFirstCall) this.startCheckSubscriptionStatus(); // Restart the timer after successful call
        },
        error: (err) => {
          console.error('Error occurred during subscription check:', err);
          if (!isFirstCall) this.startCheckSubscriptionStatus(); // Restart even on error to continue polling
        },
      });
  }

  competitorsTabDisabled: boolean = true;


  updateIcon(iconName: string) {
    //console.log(iconName);
    //console.log(this.iconsList.find(cn => cn.oldName === iconName).newName ?? '');
    return this.iconsList.find(cn => cn.oldName === iconName)?.newName ?? '';
  }

  initTemplate() {
    this.tracking.trackEvent(
      'pageview', 'Top Left Main Blue Button CTA : Create New Content'
    );
    //this.templateHelperService.openTemplateSelector();
    this.newTemplateHelperService.openTemplateSelector();
  }

  languageChanged(event: string) {
    // store preference in local storage
    this._storageHelper.UserLanguage = event;
    window.location.reload();
  }

  public openKnowledgeBase() {
    this.tracking.trackEvent(
      'pageview', 'Knowledgebase Nav Top Right'
    );
    this.router.navigate(['/whats-new']);
  }
  public openGettingStarted() {
    window.open("https://support.milestoneinternet.com/en/support/solutions/folders/158001058706", "_blank");
  }
  public openWhatsNew() {
    this.router.navigate(['/whats-new']);
  }
  public openStepByStepTutorial() {
    window.open("https://support.milestoneinternet.com/en/support/solutions/folders/158001058708", "_blank");
  }
  public openPromptRepository() {
    window.open("https://support.milestoneinternet.com/en/support/solutions/folders/158001058708", "_blank");
  }

  isMenuSelected(routerLink: string) {
    //debugger;
    return this.router.url == routerLink;
  }
  
  //isMenuSelectedBasedOnGroupName
  isMenuSelectedBOGN(routerLink: string, otherLink:string=null) {
    //debugger;
    return this.router.url.includes(routerLink) || (otherLink && this.router.url.includes(otherLink));
  }
  mpcRedirect() {
    if (this.returnUrlToMPC !== '')
      window.open(this.returnUrlToMPC, "_blank");
  }

  dprRedirect() {
    window.open(this.dprBaseUrl, "_blank");
  }

  assetLibraryRedirect() {
    if (this.returnUrlToMPC !== '') {
      window.open(this.returnUrlToMPC + "/dam/folderlist", "_blank");
    }
  }
  openAccountSettings() {
    this.tracking.trackEvent(
      'pageview', 'My Account Nav Top Right : Account Settings'
    );
    window.open(this.businessInformationUrl + this._storageHelper.user.bId);
  }
  closeManageSubscriptionSubmenu(): void {
    this.ManageSubscriptionSubMenuvisible = false;
  }

  logout() {
    this.tracking.trackEvent(
      'pageview', 'My Account Nav Top Right : CTA Logout'
    );
    this.commonService.logout();
  }

  openCustomerPortal(actionType: string) {
    if (actionType === 'subscription_update') {
      if (this.IsTrialPeriod) return;
      this.tracking.trackEvent(
        'pageview', 'My Account Nav Top Right : CTA Update Plan'
      );
    } else if (actionType === 'payment_method_update') {
      this.tracking.trackEvent(
        'pageview', 'My Account Nav Top Right : CTA Billing'
      );
    }
    this.commonService.openCustomerPortal(actionType).subscribe(
      (stripeUrl: string) => {
        if (stripeUrl) {
          window.location.href = stripeUrl;
        }
      },
      (error) => {
        console.error('Error occurred:', error);
        //if (actionType == "subscription_cancel") {
        //  if (error.errorCode == 5 && error.errorMessage.includes("is already set to be cancel")) {
        //    this.errorMessage = "Subscription is set to be canceled.";
        //  }
        //}
        this.openCancelPopup(false);
        //window.location.href = this.businessInformationUrl + this._storageHelper.user.bId;
      }
    );
  }

  openCancelPopup(isCancel: boolean = true) {
    this.tracking.trackEvent(
      'pageview', 'My Account Nav Top Right : CTA Cancel'
    );
    this.showSupportPopup = true;
    this.isCancelSubscription = isCancel;
    //if (!this.isCancelSubscription) this.errorMessage = "Unable to load, please try later or contact us if issue persists";
    this.ManageSubscriptionSubMenuvisible = false;
    this.cdRef.detectChanges();
  }

  closeCancelSubscription(openEmail: boolean = false) {
    this.isCancelSubscription = false;
    this.showSupportPopup = false;
    if (openEmail) window.location.href = "mailto:customercare@milestoneinternet.com";
  }
}
